import React, {useState} from 'react'
import './navbar.css'
import {MdOutlineTravelExplore} from 'react-icons/md'
import {AiFillCloseCircle} from 'react-icons/ai'
import {HiDotsVertical} from 'react-icons/hi'

const Navbar = () => {
  const [active, setActive] = useState('navBar')

  // toggle navBar
  const showNav = ()=>{
    setActive('navBar activeNavbar')
  }

  // close navBar
  const removeNavbar = ()=>{
    setActive('navBar')
  }

  return (
    <section className='navBarSection'>
      <header className='header flex'>
        <div className="logoDiv">
          <a href="#" className='logo flex'>
            <h1><MdOutlineTravelExplore className="icon"/> Desa Nusantara</h1>
          </a>
        </div>

        <div className={active}>
          <ul className="navLists flex">

            <li className="navItem">
              <a href="#" className="navLink">Home</a>
            </li>

            <li className="navItem">
              <a href="#" className="navLink">About</a>
            </li>

            <li className="navItem">
              <a href="#" className="navLink">Transport</a>
            </li>

            <li className="navItem">
              <a href="#" className="navLink">Accomodation</a>
            </li>

            <li className="navItem">
              <a href="#" className="navLink">News</a>
            </li>

            <li className="navItem">
              <a href="#" className="navLink">Contact</a>
            </li>
            
            <button className='btn'>
              <a href="#">Login</a>
            </button>
            <button className='btn'>
              <a href="#">Sign Up</a>
            </button>
          </ul>

          <div onClick={removeNavbar} className="closeNavbar">
            <AiFillCloseCircle className="icon"/>
          </div>
        </div>

        <div onClick={showNav} className="toggleNavbar">
          <HiDotsVertical className="icon"/>
        </div>
      </header>
    </section>
  )
}

export default Navbar